import React from 'react';
import axios from 'axios';
import { isImageFile } from './constants';
import { Loader, MinLoader } from 'components';
import { getFreshFileUrl, Images } from '../../utils';

export const FileAttachment = ({ attachment, isSent }) => {
    if (!attachment) return null;

    const fileUrl = attachment.file?.url || attachment.fileUrl;
    const thumbUrl = attachment.thumbnailUrl || fileUrl;
    const fileName = attachment.name || attachment.file?.originalName || attachment.fileName || 'file';
    const fileType = attachment.file?.format || attachment.fileType || '';
    const [selectedId, setSelectedId] = React.useState('');
    const handleClick = async () => {
        // Mint a fresh signed URL on click; the render-time fileUrl is the
        // page-load signed URL (5-min TTL) and goes stale. Fall back to the
        // legacy flat attachment.fileUrl for pre-StoredFile records.
        const url = (await getFreshFileUrl(attachment.file)) || attachment.fileUrl;
        if (url) window.open(url, '_blank', 'noopener,noreferrer');
    };
    const handleDownload = (e) => {
        e.stopPropagation();

        const fileType = attachment?.file?.originalName
            ? attachment?.file?.originalName
            : attachment?.file?.format === 'svg+xml'
              ? 'file.svg'
              : `file.${attachment?.file?.format}`;

        // Signed S3 GET URL stamped by backend sanitizer. useBaseUrl:false
        // so the axios interceptor doesn't prefix it with /api/….
        if (!attachment?.file?.url) return;
        setSelectedId(attachment?._id);
        axios({
            url: attachment.file.url,
            method: 'GET',
            responseType: 'blob',
            useBaseUrl: false,
        })
            .then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileType);
                document.body.appendChild(link);
                link.click();
                setSelectedId('');
            })
            .catch(() => {
                setSelectedId('');
            });
    };

    if (isImageFile(fileType)) {
        return (
            <div className="chat-file-attachment-container">
                <img src={thumbUrl || fileUrl} alt={fileName} className="chat-file-attachment-image" onClick={handleClick} />
            </div>
        );
    }

    return (
        <div className="chat-file-attachment-container">
            <div
                className={`chat-file-attachment-file ${isSent ? 'chat-file-attachment-sent' : 'chat-file-attachment-received'}`}
                onClick={handleClick}
            >
                <div className="chat-file-attachment-icon">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                        <path
                            d="M10.5 1.5H4.5A1.5 1.5 0 003 3v12a1.5 1.5 0 001.5 1.5h9A1.5 1.5 0 0015 15V6L10.5 1.5z"
                            stroke="#347AF0"
                            strokeWidth="1.3"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path d="M10.5 1.5V6H15" stroke="#347AF0" strokeWidth="1.3" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                </div>
                <div className="chat-file-attachment-info">
                    <p>{fileName}</p>
                </div>
                <button className="chat-file-attachment-download" onClick={(e) => handleDownload(e)} title="Download" type="button">
                    {selectedId === attachment?._id ? (
                        <MinLoader width={'18px'} height={'18px'} margin={'0'} color={'#D0D5DD'} position={'relative'} />
                    ) : (
                        <img src={Images.downloadPdf} alt="download" />
                    )}
                </button>
            </div>
        </div>
    );
};
